import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MainNavigation from './MainNavigation';
import UserMenu from './auth/UserMenu';
import ShoppingCart from './ShoppingCart';
import MaterialIcon from './MaterialIcon';
import { useAuthModals } from './auth/AuthModalManager';
import { useCart } from '../contexts/CartContext';
import featureFlags from '../config/featureFlags';
import './MainHeader.css';

const MainHeader = ({ currentPage = 'home', onVisibilityChange }) => {
  const headerRef = useRef(null);
  const { openLogin, openSignup } = useAuthModals();
  const { itemCount } = useCart();
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    // Skip if no callback provided
    if (!onVisibilityChange) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Callback with visibility state
        onVisibilityChange(entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px',
      }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [onVisibilityChange]);

  return (
    <>
      <header className="main-header" ref={headerRef}>
        <div className="header-content">
          <div className="header-logo">
            <img src="/assets/svgs/clothedEye.svg" alt="ClothedEye" />
          </div>
          <MainNavigation currentPage={currentPage} />
          <div className="header-user-section">
            {/* Shopping Cart Button - 🚧 Feature Flag Controlled */}
            {featureFlags.enableShoppingCart && (
              <button
                className="header-cart-button"
                onClick={() => setIsCartOpen(true)}
                aria-label="Shopping cart"
              >
                <MaterialIcon icon="shopping_cart" />
                {itemCount > 0 && <span className="header-cart-badge">{itemCount}</span>}
              </button>
            )}

            {/* User Menu */}
            <UserMenu onLoginClick={openLogin} onSignupClick={openSignup} />
          </div>
        </div>
      </header>

      {/* Shopping Cart Drawer - 🚧 Feature Flag Controlled */}
      {featureFlags.enableShoppingCart && (
        <ShoppingCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      )}
    </>
  );
};

MainHeader.propTypes = {
  currentPage: PropTypes.string,
  onVisibilityChange: PropTypes.func,
};

export default MainHeader;
